<template>
    <div class="sub-menu" :id="id">
        <transition name="fade">
            <div v-show="showContent" class="menu-content">
                <img :src="area.bgImg" :class="{ blurred : currentGroup != null }" />
                <div class="hotspots" v-show="currentGroup == null">
                    <hotspot v-for="group in product_groups" :key="group.handle" :area="group" @click.native="currentGroup = group.handle"></hotspot>
                </div>
                <div class="menu-buttons" v-show="currentGroup == null">
                    <button type="button" @click="closeSubMenu" class="area-close">Back</button>
                </div>
            </div>
        </transition>
        <transition name="fade" v-for="group in product_groups" :key="group.handle">
            <product-menu :group="group" v-if="currentGroup == group.handle" @close-product-menu="currentGroup = null" @close-sub-menu="closeSubMenu"></product-menu>
        </transition>
        <video class="transition-video" v-show="showVideo" preload="auto" muted>
            <source :src="area.intro_video" type="video/mp4" />
        </video>
    </div>
</template>
<script>
import $ from 'jquery';
window.$ = require('jquery');
    import _ from 'lodash';
    import SubAreas from '../data-src/SubAreas.json';
    import ProductMenu from './ProductMenu.vue';
    import Hotspot from './Hotspot-item.vue';

    export default {
        props : ["id","area"],
        components : {
            Hotspot,
            ProductMenu
        },
        data() {
            return {
                product_groups : [],
                currentGroup : null,
                showVideo : true,
                showContent : false
            }
        },
        computed : {
            video() {
                return this.$el.querySelector('video');
            }
        },
        created() {
            this.product_groups = _.filter(SubAreas, (subarea) => {
                return _.findIndex(this.area.sub_areas, function(o) {
                    return o == subarea.handle;
                }) > -1;
            });
        },
        mounted() {
            this.video.play();

            this.video.addEventListener('playing', () => {
                this.showContent = true;
            });

            this.video.addEventListener('ended', () => {
                this.showVideo = false;
            });

            let hotspots = this.$el.querySelectorAll('.hotspot');

            let interval = 1;

            hotspots.forEach(hotspot => {
                setTimeout(function() {
                    $(hotspot).addClass('animated');
                },interval);
                interval += 2000;
            });

            this.$root.$on('touch-here-mode', function(e) {
                if( e ) {
                    let rand = (Math.floor((Math.random() * hotspots.length) + 1)-1);
                    $(hotspots[rand]).addClass('touchable');

                    setTimeout(function() {
                        $(hotspots[rand]).removeClass('touchable');
                    }, 3000)
                } else {
                    $(hotspots).removeClass('touchable');
                }
            });
        },
        methods : {
            closeSubMenu() {
                $(this.video).removeAttr('style');
                this.video.load();
                this.$emit('close-sub-menu');
            }
        }
    }
</script>